import { createFileRoute } from '@tanstack/react-router';
import { OfficeLobbyPage } from '@/features/office/office-lobby-page';

export const Route = createFileRoute('/w/$workspaceId/office/')({ component: OfficeLobbyPage });
